import { render, staticRenderFns } from "./jala-region-select-ajax.vue?vue&type=template&id=b9cf653e&scoped=true&"
import script from "./jala-region-select-ajax.vue?vue&type=script&lang=js&"
export * from "./jala-region-select-ajax.vue?vue&type=script&lang=js&"
import style0 from "./jala-region-select-ajax.vue?vue&type=style&index=0&id=b9cf653e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9cf653e",
  null
  
)

export default component.exports